'use strict';

const classNames = {
    active: 'is-active',
    targetActive: 'target-active',
};
const dataset = {
    hidden: 'data-showhide-hidden-attribute',
};

export default class Showhide {
    constructor(component) {
        this.component = component;
        this.toggleSelector = component.getAttribute('data-showhide-toggle');
        this.toggleTargets = this.toggleSelector
            ? document.querySelectorAll(this.toggleSelector)
            : null;
        this.showSelector = component.getAttribute('data-showhide-show');
        this.showTargets = this.showSelector ? document.querySelectorAll(this.showSelector) : null;
        this.hideSelector = component.getAttribute('data-showhide-hide');
        this.hideTargets = this.hideSelector ? document.querySelectorAll(this.hideSelector) : null;

        this.init();
        this.hideSimpleDropdown();
    }

    _toggleAttributes(element, attribute) {
        if (element.hasAttribute(attribute)) {
            element.removeAttribute(attribute);
        } else {
            element.setAttribute(attribute, 'true');
        }
    }

    _handleToggleTargets() {
        const activeElements = document.querySelectorAll(`.${classNames.targetActive}`);
        activeElements.forEach((element) => {
            if (element !== this.component) {
                element.classList.remove(classNames.targetActive);
                element.setAttribute('aria-expanded', 'false');
            }
        });

        this.component.classList.toggle(classNames.targetActive);
        this.component.setAttribute(
            'aria-expanded',
            this.component.classList.contains(classNames.targetActive)
        );
        this.toggleTargets.forEach((target) => {
            target.classList.toggle(classNames.active);
            this._toggleAttributes(target, 'aria-hidden');
        });
    }

    _handleHideTargets() {
        const triggers = document.querySelectorAll(
            `[data-showhide-show="${this.hideSelector}"],[data-showhide-toggle="${this.hideSelector}"]`
        );

        triggers.forEach((trigger) => {
            trigger.classList.remove(classNames.targetActive);
            trigger.setAttribute('aria-expanded', 'false');
        });

        this.hideTargets.forEach((target) => {
            if (this.component.hasAttribute(dataset.hidden)) {
                target.setAttribute('hidden', 'true');
            } else {
                target.classList.remove(classNames.active);
            }

            target.setAttribute('aria-hidden', 'true');
        });
    }

    _handleShowTargets() {
        this.component.classList.add(classNames.targetActive);
        this.component.setAttribute('aria-expanded', 'true');

        this.showTargets.forEach((target) => {
            if (this.component.hasAttribute(dataset.hidden)) {
                target.removeAttribute('hidden');
            } else {
                target.classList.add(classNames.active);
            }

            target.removeAttribute('aria-hidden');
        });
    }

    init() {
        if (this.toggleTargets) {
            this.component.addEventListener('click', this._handleToggleTargets.bind(this));
        }

        this.component.addEventListener('click', () => {
            if (this.hideTargets) {
                this._handleHideTargets();
            }
            if (this.showTargets) {
                this._handleShowTargets();
            }
        });
    }

    // Hide simple dropdown menu when clicked on document body (outside dropdown).
    hideSimpleDropdown() {
        document.addEventListener('click', function(e) {
            const clickTarget = e.target;
            const isSimpleDropdown = clickTarget.classList.contains('link--dropdown-simple');
            const isHeaderSearchTrigger = clickTarget.closest('.header-search-trigger') !== null;
            const isHeaderSearchInput = clickTarget.closest('.header-search-wrapper') !== null;

            // Check if click event is outside active element
            const isActiveElement = clickTarget.classList.contains('target-active');
            const isInsideActiveElement = clickTarget.closest('.target-active') !== null;

            if (!isActiveElement && !isInsideActiveElement) {
                const activeElements = document.querySelectorAll('.target-active');

                activeElements.forEach((element) => {
                    element.classList.remove('target-active');
                    element.setAttribute('aria-expanded', 'false');
                });
            }

            if (!isSimpleDropdown) {
                const simpleDropdowns = document.querySelectorAll('.link--dropdown-simple');
                const menus = document.querySelectorAll('.bu-header__nav__select');

                simpleDropdowns.forEach((target) => {
                    target.classList.remove('target-active');
                    target.setAttribute('aria-expanded', 'false');
                });

                menus.forEach((target) => {
                    target.classList.remove('is-active');
                    target.removeAttribute('aria-hidden');
                });
            }

            if (!(isHeaderSearchTrigger || isHeaderSearchInput)) {
                const elements = document.querySelectorAll(
                    '.bu-header__wrapper .header-search.is-active'
                );

                elements.forEach((e) => {
                    e.classList.remove('is-active');
                });
            }
        });
    }
}
